import React, { Component } from 'react';

export default class TransportPurchasing extends Component {
    render() {
        return <h1>Purchasing</h1>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Transport/components/Purchasing/Purchasing.js